import angular from 'angular';

angular.module('core.tag.values.components', []);